module.exports = "/assets/data/d98169f07c315ee58a85c40d3febc624-LE3.data.json";